var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDiscussSupport = function SvgIconDiscussSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-discuss-support_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F8DFD8",
    d: "M14.812 4.063H2.156L2.11 9.686h12.703zm7.079 4.921h-5.672a.703.703 0 0 0-.704.703v1.407a.704.704 0 0 1-.703.703H9.187a.703.703 0 0 0-.703.703v7.078c0 1.163.947 2.11 2.11 2.11h5.334l2.606 2.606a.703.703 0 0 0 1.2-.497v-2.11h2.156c1.164 0 2.11-.946 2.11-2.109v-8.484c0-1.163-.946-2.11-2.11-2.11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#icon-discuss-support_svg__b)",
    d: "M13.406 14.61a.703.703 0 1 0 0 1.406.703.703 0 0 0 0-1.407m2.813 0a.703.703 0 1 0 0 1.406.703.703 0 0 0 0-1.407m2.812 0a.703.703 0 1 0 0 1.406.703.703 0 0 0 0-1.407M14.812.5H2.11C.942.5 0 1.442 0 2.61v8.484c0 1.167.942 2.109 2.11 2.109h2.156v2.11c0 .28.168.534.436.646a.67.67 0 0 0 .759-.154l2.615-2.602h6.736c1.168 0 2.11-.942 2.11-2.11V2.61c0-1.167-.942-2.109-2.11-2.109M3.562 4.766H4.97c.393 0 .703.309.703.703s-.31.703-.703.703H3.562a.696.696 0 0 1-.703-.703c0-.394.31-.703.703-.703m9.844 4.218H3.562a.696.696 0 0 1-.703-.703c0-.394.31-.703.703-.703h9.844c.394 0 .703.31.703.703 0 .394-.31.703-.703.703m0-2.812H7.781a.696.696 0 0 1-.703-.703c0-.394.31-.703.703-.703h5.625c.394 0 .703.309.703.703s-.31.703-.703.703"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-discuss-support_svg__b",
    x1: 0,
    x2: 14.753,
    y1: 8.258,
    y2: -0.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA564"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-discuss-support_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h24v24H0z"
  })))));
};
export default SvgIconDiscussSupport;